import { clsx } from 'clsx';
import { BrandSwitch } from '../../../components/BrandSwitch';

type NotificationToggleProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
  ariaLabel: string;
  disabled?: boolean;
  /** Text after the "on" bell (the dialog); omitted in dense rows (the drawer). */
  label?: string;
  'data-testid'?: string;
};

/**
 * Receive-notifications switch framed by its meaning: a crossed-out bell on
 * the off side, a bell on the on side. The icon for the current state is
 * emphasised so the switch doesn't have to be read on its own.
 */
export function NotificationToggle({
  checked,
  onChange,
  ariaLabel,
  disabled = false,
  label,
  'data-testid': testId,
}: NotificationToggleProps) {
  return (
    <div className="tw:flex tw:items-center tw:gap-2">
      <i
        className={clsx('far fa-bell-slash', checked ? 'tw:text-zinc-300' : 'tw:text-zinc-600')}
        aria-hidden="true"
        title="Notifications off"
      />
      <BrandSwitch
        small
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        aria-label={ariaLabel}
        data-testid={testId}
      />
      <i
        className={clsx('far fa-bell', checked ? 'tw:text-brand-green-0' : 'tw:text-zinc-300')}
        aria-hidden="true"
        title="Notifications on"
      />
      {label && <span className="tw:text-sm">{label}</span>}
    </div>
  );
}
